
export default () => ({
  id: 0,
  type: 'success', // research, notActual, price_change, meal_change, room_change, vehicle_change
  status: 'loadingAllowed', // stop, pending
  errors: [],
  errorsServices: []
})
